// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { getfeedbackTotalRecord } from '../../store/state/feedbackSlice';
import { useFindAllCustomerFeedbackMutation,
  useFindCustomerFeedbackByIdMutation,
  useGetAllCustomerFeedbackMutation,
  useFindCustomerFeedbackByBookingIdMutation,
  useSaveCustomerFeedbackMutation,
  useUpdateCustomerFeedbackMutation,
  useDeleteCustomerFeedbackMutation, } from '../../store/api/feedbacksApi';
import { setFeedback } from '../../store/state/feedbackSlice';

const TABLE_HEAD = [
  { id: 'name ', label: 'Customer Name', alignRight: false },
  { id: 'drvierRating', label: 'Driver Rating', alignRight: false },
  { id: 'rating', label: 'Customer Service Experience', alignRight: false },
  { id: 'comment', label: 'Comment', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export default function Testimonial() {
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [findAllCustomerFeedback, findAllCustomerFeedbackResponse ]= useFindAllCustomerFeedbackMutation();
  const [getAllCustomerFeedback, getAllCustomerFeedbackResponse]= useGetAllCustomerFeedbackMutation();
  const [updateCustomerFeedback, updateCustomerFeedbackResponse ]= useUpdateCustomerFeedbackMutation();
  const [findCustomerFeedbackById, findCustomerFeedbackByIdResponse]= useFindCustomerFeedbackByIdMutation();
  const [testimonialManagementData, setTestimonialManagementData] = useState([]);
  const feedbackTotalRecord = useAppSelector(getfeedbackTotalRecord);
  const [feedbackId, setFeedbackId] = useState<number>();
  const [updateState, setUpdateState] = useState({});
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);

  const filteredUsers = testimonialManagementData;
  const isUserNotFound = filteredUsers.length === 0;


  useEffect(() => {
    getAllCustomerFeedback({
      token: token.token,
      payload:{
      offset: 5,
      page: 0,
    }
    });
  }, [getAllCustomerFeedback]);

  useEffect(() => {
    if (getAllCustomerFeedbackResponse.isSuccess) {
      dispatch(setFeedback(getAllCustomerFeedbackResponse.data));
      setTestimonialManagementData(getAllCustomerFeedbackResponse.data.data);
    }
    if (getAllCustomerFeedbackResponse.isError) {
      let errorData: any = getAllCustomerFeedbackResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllCustomerFeedbackResponse.isSuccess, getAllCustomerFeedbackResponse.isError]);

  useEffect(() => {
    if (updateCustomerFeedbackResponse.isSuccess) {
      getAllCustomerFeedback({
        token: token.token,
        payload: {
          page: page,
          offset: rowsPerPage,
        },
      });
    }
    if (updateCustomerFeedbackResponse.isError) {
      let errorData: any = updateCustomerFeedbackResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateCustomerFeedbackResponse.isSuccess, updateCustomerFeedbackResponse.isError]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllCustomerFeedback({ token: token.token, payload:{offset: rowsPerPage, page: newPage},  });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllCustomerFeedback({
      token: token.token,
      payload:{
       offset: parseInt(event.target.value, 10), 
       page: 0 ,
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    getAllCustomerFeedback({
      token: token.token,
      payload:{
        offset: rowsPerPage,
        page: 0,
        searchValue: event.target.value,
      },
    });
  };

  const handleUpdate = () => {
    setOpen(false);
    
    const feedbackEntry = filteredUsers.find(user => user.id === feedbackId);

    const newStatus = feedbackEntry?.status ? false : true;

    console.log("Feedback Handle updated id", feedbackId, "New Status:", newStatus);

    updateCustomerFeedback({
      token: token.token,
      payload:{
        status:newStatus,
        id: feedbackId,
      }
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  return (
    <Page title="Testimonial">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Testimonial
          </Typography>
         {/**  <Button
            variant="contained"
            style={{ color: 'white', backgroundColor: '#E23744' }}
            onClick={() => {
              navigate('/dashboard/add-testimonial', {
                state: {
                  editMode: false,
                },
              });
            }}
            startIcon={<Iconify icon="eva:plus-fill" />}
            size="large"
          >
            Add
          </Button> */}
        </Stack>
        <Card>
         {/**  <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Customer Name'}
          /> */}
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  headLabel={TABLE_HEAD}
                  rowCount={testimonialManagementData.length}
                  numSelected={selected.length}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, driverRating, customerName, rating, comments, isTestimonial, customerObj, status } = row;
                      const isItemSelected = selected.indexOf(customerObj?.name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          {/**<TableCell align="left">
                            <Avatar
                              alt="Remy Sharp"
                              style={{
                                backgroundColor: 'pink',
                                fontSize: '20px',
                                fontWeight: 'bold',
                              }}
                            >
                              {customerObj?.name !== null
                                ? customerObj?.name?.charAt(0).toUpperCase()
                                : 'N/A'}
                            </Avatar>
                          </TableCell> */}
                          <TableCell align="left" style={{ cursor: 'pointer' }}>
                            <Typography fontWeight="normal" variant="subtitle2">
                              {customerObj?.name !== null ? customerObj?.name : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {driverRating}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" style={{ cursor: 'pointer' }}>
                            <Typography fontWeight="normal" variant="subtitle2">
                              {rating}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" style={{ cursor: 'pointer' }}>
                            <Typography fontWeight="normal" variant="subtitle2">
                              {comments}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status === true}
                                onClick={() => {
                                  setFeedbackId(id);
                                  console.log("Feedback Id:",id);
                                  handleOpen();
                                  setUpdateState(isTestimonial);
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={feedbackTotalRecord || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  sx={{ margin: '10px' }}
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                  onClick={handleUpdate}
                  sx={{ margin: '10px' }}
                >
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}

        {updateCustomerFeedbackResponse.isLoading || getAllCustomerFeedbackResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
